import { BatchItemResult } from './api/pdfBatchTypes';
export const MAX_CONCURRENT_UPLOADS = 1;

export const makeEmptyItem = (fileName: string): BatchItemResult => ({
  fileName,
  status: 'Pending',
  processedAtUtc: null,
  householdId: null,
  principalName: null,
  warnings: [],
  errors: [],
  summary: null,
  sourceSystem: null,
  spouseName: null,
  dependentCount: 0,
  accountCount: 0,
  goalCount: 0,
  incomeCount: 0,
  expenseCount: 0,
  otherAssetCount: 0,
  insuranceCount: 0,
  trustCount: 0,
  riskToleranceScore: null,
  principalAge: null,
  spouseAge: null,
  netWorth: null,
  annualIncome: null,
  planningInsights: [],
});
